module.exports = __webpack_public_path__ + "img/pIndex-about3.392b059d.jpg";